import React, { createContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { CopilotSuggestionsTracker } from '@bingads-webui-campaign-react/copilot-common';

// Create the logging context
export const LoggingContext = createContext([{}, () => {}]);

// Custom hook to access the logging context

// Provider component to wrap your app with the logging context
export const LoggingProvider = ({ children }) => {
  const [loggingContext, setLoggingContext] = useState({
    copilotTracking: new CopilotSuggestionsTracker(),
    postAssetEventLog: () => {},
  });

  const updateLoggingContext = useCallback((newContext) => {
    setLoggingContext(prevContext => ({
      ...prevContext,
      ...newContext,
    }));
  }, []);

  return (
    <LoggingContext.Provider value={[loggingContext, updateLoggingContext]}>
      {children}
    </LoggingContext.Provider>
  );
};

LoggingProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const withLoggingContext = (WrappedComponent) => {
  const HoC = props => (
    <LoggingProvider>
      <WrappedComponent {...props} />
    </LoggingProvider>
  );
  HoC.displayName = `WithLoggingContext(${getDisplayName(WrappedComponent)})`;

  hoistNonReactStatics(HoC, WrappedComponent);

  return HoC;
};
